import React from 'react';
interface TCPAConsentProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
}
export function TCPAConsent({
  checked,
  onChange,
  error
}: TCPAConsentProps) {
  return <div className="mt-4 mb-6" data-id="element-968" data-mp="2arjymsj7ugba">
      <div className="flex items-start" data-id="element-969" data-mp="2aslct5vj3ix8">
        <div className="flex items-center h-5" data-id="element-970" data-mp="25t0gz4bnnqoq">
          <input id="tcpa-consent" name="tcpa-consent" type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} className="focus:ring-navy h-4 w-4 text-crimson border-gray-300 rounded cursor-pointer" data-id="element-971" data-mp="25ubfopq8u88z" />
        </div>
        <div className="ml-3 text-xs text-gray-500 leading-tight" data-id="element-972" data-mp="2yftjns8lv01d">
          <label htmlFor="tcpa-consent" className="cursor-pointer" data-id="element-973" data-mp="2th03fs1xouxi">
            By checking this box, I consent to receive emails, phone calls, and
            SMS text messages from FindOnlineColleges.org and its partner schools at
            the email and phone number provided, including my wireless number if
            provided. I understand these calls may be generated using an
            automated technology. I understand that my consent is not required
            to use this service or to enroll in a program.
          </label>
        </div>
      </div>
      {error && <p className="mt-2 text-sm text-red-600" data-id="element-974" data-mp="1cqwdveb6klhw">{error}</p>}
    </div>;
}